import { render, staticRenderFns } from "./EscalaUpp.vue?vue&type=template&id=3710f65c&"
import script from "./EscalaUpp.vue?vue&type=script&lang=js&"
export * from "./EscalaUpp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports